import React, { useState } from 'react';
import { LegalModal, type LegalDoc } from './LegalModal';
export function Footer() {
  const [legalDoc, setLegalDoc] = useState<LegalDoc | null>(null);
  return <footer className="border-t border-rule pb-10 pt-[26px]" data-id="element-61" data-mp="32nun0sijob3h">
      <div className="mx-auto flex max-w-shell flex-col gap-3 px-[clamp(20px,5vw,64px)] md:flex-row md:flex-wrap md:items-center md:justify-between md:gap-4" data-id="element-62" data-mp="32pp6e2e63v5g">
        <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-ink-45" data-id="element-63" data-mp="3uesani6215i3">
          &copy; {new Date().getFullYear()} Alex Circei
        </p>

        <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-ink-45" data-id="element-64" data-mp="36mrefh5qqqd">
          Co-founder &amp; CEO, Waydev
          <span className="px-2 text-rule" data-id="element-65" data-mp="3qd6spieny111">/</span>
          Y Combinator W21
        </p>

        <div className="flex gap-5" data-id="element-66" data-mp="29z6ucbvgujfw">
          <button onClick={() => setLegalDoc('privacy')} className="font-mono text-[11px] uppercase tracking-[0.14em] text-ink-45 underline-offset-4 transition-colors duration-200 ease-editorial hover:text-signal hover:underline" data-id="element-67" data-mp="29y5gjzn2fiuh">
            Privacy Policy
          </button>
          <button onClick={() => setLegalDoc('terms')} className="font-mono text-[11px] uppercase tracking-[0.14em] text-ink-45 underline-offset-4 transition-colors duration-200 ease-editorial hover:text-signal hover:underline" data-id="element-68" data-mp="3gbqxme8zyjad">
            Terms of Service
          </button>
        </div>
      </div>

      <LegalModal doc={legalDoc} onClose={() => setLegalDoc(null)} data-id="element-69" data-mp="80nsyi3daocc" />
    </footer>;
}